
import { defineComponent, reactive } from 'vue'
import { vMaska, MaskaDetail } from 'maska'

export default defineComponent({
  inheritAttrs: false,
  directives: { mask: vMaska },
  setup() {
    const opts = {
      mask: '+7(###) ###-##-##',
    }

    const binded: MaskaDetail = reactive({
      masked: '',
      unmasked: '',
      completed: false,
    })

    return {
      opts,
      binded,
    }
  },
})
